//frontend/src/pages/admin/Reports.jsx
import AdminLayout from '../../components/layout/AdminLayout';

const Reports = () => {
  return (
    <AdminLayout>
      <div className="text-center py-20">
        <div className="mb-6">
          <span className="text-8xl">📈</span>
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Тайлан тооцоо
        </h1>
        <p className="text-gray-600 mb-8">
          Энэ хуудас хөгжүүлэгдэж байна...
        </p>
        <div className="inline-block px-6 py-3 bg-blue-100 text-blue-800 rounded-lg font-medium">
          🚧 Удахгүй нээгдэнэ
        </div>
      </div>
    </AdminLayout>
  );
};

export default Reports;